import { isTypeObject as e } from "./is-type-object.js";
import { partitionAllOfCompositions as t } from "./partition-all-of-compositions.js";
//#region src/schema/helpers/normalize-object-composition.ts
var n = (n, r) => {
	if (!r || !n?.allOf || n.oneOf || n.anyOf || n.not) return n;
	let { segments: i } = t(n), a = i[0];
	if (i.length !== 1 || a?.kind !== "object" || !e(a.schema)) return n;
	let o = { ...a.schema };
	"$ref" in o && delete o.$ref;
	let s = {
		title: n.title,
		description: n.description,
		deprecated: n.deprecated,
		readOnly: n.readOnly,
		writeOnly: n.writeOnly,
		example: n.example,
		examples: n.examples,
		nullable: n.nullable
	};
	return {
		...o,
		...s,
		..."$ref" in n && typeof n.$ref == "string" ? { $ref: n.$ref } : {}
	};
};
//#endregion
export { n as normalizeObjectComposition };

//# sourceMappingURL=normalize-object-composition.js.map